import { buildQueryString } from '../utils/StringUtils';

import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

// export const clearSearchedGlobalContentRow = () => dispatch => {
//   dispatch({
//     type: ACTIONS.CLEAR_SEARCHED_GLOBAL_CONTENT_ROW,
//   });
// };

/**
 *
 * @param {Object} params
 * @param {String} actionType
 * @return {function(*)}
 * @private
 */
const _getManyGlobalContentRow = (params, actionType) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/globalcontentrows`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: actionType,
                payload: {
                    globalContentRows: body
                }
            });
            return body;
        });
};

/**
 *
 * @param {Object} query
 * @return {function(*)}
 */
export const getFilteredGlobalContentRow = (query) =>
    _getManyGlobalContentRow(query, ACTIONS.GET_FILTERED_GLOBAL_CONTENT_ROW);

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
export const getManyGlobalContentRows = (params) =>
    _getManyGlobalContentRow(params, ACTIONS.GET_MANY_GLOBAL_CONTENT_ROWS);

export const getGlobalContentRow = (params, query = {}) => {
    const { globalContentRowId, pathsContext } = params;
    return (dispatch) => {
        const baseUrl = `${pathsContext.adminServerUrl}/globalcontentrows/${globalContentRowId}`;
        const url = buildQueryString(query, baseUrl);
        return VerbFetch(url).then((globalContentRowBody) => {
            dispatch({
                type: ACTIONS.GET_GLOBAL_CONTENT_ROW,
                payload: {
                    GlobalContentRow: globalContentRowBody
                }
            });

            return globalContentRowBody;
        });
    };
};

export const postGlobalContentRow = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_GLOBAL_CONTENT_ROW_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/globalcontentrows`, {
            method: 'POST',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.POST_GLOBAL_CONTENT_ROW_SUCCESS,
                payload: {
                    globalContentRow: result
                }
            });

            return result;
        });
    };
};

export const putGlobalContentRow = (params) => {
    const { globalContentRowId, body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_GLOBAL_CONTENT_ROW_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/globalcontentrows/${globalContentRowId}`, {
            method: 'PUT',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_GLOBAL_CONTENT_ROW_SUCCESS,
                payload: {
                    globalContentRow: result
                }
            });

            return result;
        });
    };
};
